'use client';

import { c as _c } from "react/compiler-runtime";
import { useCart, useIsMounted, useLoyaltyContext, useUserSession } from '@libs/common-next';
import { getAccessToken, isLastActiveExpired } from '@libs/core';
export function useAccountDropdown() {
  const $ = _c(16);
  const {
    cart
  } = useCart();
  const {
    memberPoints
  } = useLoyaltyContext();
  const {
    storageUserSession,
    userData,
    isSoftAuthenticated,
    user
  } = useUserSession();
  const {
    isMounted
  } = useIsMounted();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = !!getAccessToken() && !isLastActiveExpired();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const hasAccessToken = t0;
  const hasTokenCookies = isMounted && hasAccessToken;
  const isPendingLoggedInState = !isMounted && hasAccessToken;
  const isLoggedIn = isPendingLoggedInState || hasTokenCookies || !!user;
  const t1 = memberPoints?.firstName ?? userData?.profile?.firstName ?? "";
  let t2;
  if ($[1] !== t1) {
    t2 = t1.trim();
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const firstName = t2;
  const loyaltyPoints = isSoftAuthenticated ? 0 : memberPoints?.availablePoints ?? storageUserSession?.loyaltyPoints ?? 0;
  let t3;
  if ($[3] !== isSoftAuthenticated || $[4] !== loyaltyPoints) {
    t3 = isSoftAuthenticated ? "****" : new Intl.NumberFormat("en-US", {
      maximumFractionDigits: 0
    }).format(loyaltyPoints || 0);
    $[3] = isSoftAuthenticated;
    $[4] = loyaltyPoints;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const loyaltyPointsText = t3;
  const t4 = isSoftAuthenticated ? 0 : memberPoints?.availableDollars ?? 0;
  const t5 = memberPoints?.currentTierLevel ?? "member";
  const t6 = isPendingLoggedInState || isLoggedIn && !firstName;
  const t7 = cart?.summary?.itemCount ?? undefined;
  let t8;
  if ($[6] !== firstName || $[7] !== isLoggedIn || $[8] !== isSoftAuthenticated || $[9] !== loyaltyPoints || $[10] !== loyaltyPointsText || $[11] !== t4 || $[12] !== t5 || $[13] !== t6 || $[14] !== t7) {
    t8 = {
      availableDollars: t4,
      currentMemberLevel: t5,
      isLoading: t6,
      isLoggedIn,
      isSoftAuthenticated,
      firstName,
      loyaltyPoints,
      loyaltyPointsText,
      qty: t7
    };
    $[6] = firstName;
    $[7] = isLoggedIn;
    $[8] = isSoftAuthenticated;
    $[9] = loyaltyPoints;
    $[10] = loyaltyPointsText;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
}